window.addEventListener("Angle3DCustomizerLoaded", (event) => {
  const { productHandle, productId, modelId } = event.detail;

  // Add to cart event listener to handle loading state and redirect
  window.addEventListener("Angle3DAddToCart", function(event) {
    console.log('Angle3DAddToCart', JSON.stringify(event.detail));

    // Remove loading state from custom button
    const customButton = document.querySelector('.tda-custom__add');
    if (customButton) {
      customButton.disabled = false;
      customButton.innerHTML = 'Add to Cart';
      customButton.classList.remove('loading');
    }

    // Redirect to cart page
    window.location.href = '/cart';
  });

  // -------------------------------------------------------
  // CUSTOM COLOR PICKER SETUP (ported from Wine Totes)
  // -------------------------------------------------------
  function setupCustomColorOption(content, contentInput, titleText) {
    // Hide the original input
    if (contentInput) contentInput.style.display = 'none';
    if (contentInput) contentInput.value = '';

    // Create color swatch wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'custom-color-picker-wrapper';

    const colorInput = document.createElement('input');
    colorInput.type = 'color';
    colorInput.className = 'custom-color-picker-input';

    const initial = contentInput && contentInput.value ? contentInput.value : '#000000';
    colorInput.value = initial;
    wrapper.style.backgroundColor = initial;

    // Create checkbox + label
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.style.marginRight = '8px';

    const checkboxLabel = document.createElement('label');
    checkboxLabel.textContent = ' Use custom color';
    checkboxLabel.style.cursor = 'pointer';
    checkboxLabel.prepend(checkbox);

    // Find the corresponding accordion button by title text
    const findCorrespondingButton = () => {
      const allButtons = document.querySelectorAll('button.tda-accordion');
      for (let btn of allButtons) {
        const btnText = btn.textContent || btn.innerText;
        if (btnText.includes(titleText)) {
          return btn;
        }
      }
      return null;
    };

    // Update the accordion button's color display
    const updateButtonColorDisplay = (color) => {
      const button = findCorrespondingButton();
      if (button) {
        const detailSection = button.querySelector('.selected-option-value-detail-section');
        if (detailSection) {
          if (color && checkbox.checked) {
            detailSection.textContent = color;
            detailSection.style.display = 'inline-block';
            detailSection.style.marginLeft = '8px';
          } else {
            detailSection.textContent = '';
            detailSection.style.display = 'none';
          }
        }
      }
    };

    // Apply or clear the color value on the hidden input
    const applyColorValue = () => {
      if (checkbox.checked) {
        const col = colorInput.value;
        wrapper.style.backgroundColor = col;
        if (contentInput) {
          contentInput.value = col;
          contentInput.dispatchEvent(new Event('input', { bubbles: true }));
          contentInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        updateButtonColorDisplay(col);
      } else {
        if (contentInput) {
          contentInput.value = '';
          contentInput.dispatchEvent(new Event('input', { bubbles: true }));
          contentInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        updateButtonColorDisplay(null);
      }
    };

    colorInput.addEventListener('input', applyColorValue);
    colorInput.addEventListener('change', applyColorValue);
    checkbox.addEventListener('change', () => {
      applyColorValue();
      handlePriceTabsOnCheckbox(checkbox);
      setTimeout(() => {
        const qty = document.querySelector('.tda-customizer-footer-qty');
        if (qty) {
          const qtyInput = qty.querySelector('input.quantity-field');
          if (qtyInput) {
            const qtyNum = document.querySelector('.total-prd-qty-num');
            if (qtyNum) {
              qtyNum.textContent = qtyInput.value;
            }
          }
        }
        updateTieredPricePerItem();
      }, 300);
    });

    wrapper.appendChild(colorInput);
    return { wrapper, checkboxLabel };
  }

  // -------------------------------------------------------
  // HANDLE PRICE TABS WHEN CUSTOM COLOR CHECKBOX CHANGES
  // MOQ = 100 for Wine N Roll (not 500 like Wine Totes)
  // -------------------------------------------------------
  function handlePriceTabsOnCheckbox(checkbox) {
    // Collect ALL custom color checkboxes
    const allCustomColorCheckboxes = [];
    const customColorOptions = document.querySelectorAll('.tda-customizer-customization-option');

    customColorOptions.forEach(option => {
      const titleEl = option.querySelector('.tda-customizer-customization-option-title');
      if (titleEl && titleEl.textContent.trim().includes('Custom')) {
        const checkboxInOption = option.querySelector('.custom-color-control-wrapper input[type="checkbox"]');
        if (checkboxInOption) {
          allCustomColorCheckboxes.push(checkboxInOption);
        }
      }
    });

    const anyChecked = allCustomColorCheckboxes.some(cb => cb.checked);

    const allTabs = document.querySelectorAll('.product-main__price-tab');
    const overseasTabs = document.querySelectorAll('.product-main__price-tab.product-main__price-tab-overseas');
    const qty = document.querySelector('.tda-customizer-footer-qty');
    const moqNote = document.querySelector('.MOq_Note');
    if (!qty) return;
    const quantityInput = qty.querySelector('input.quantity-field');
    if (!quantityInput) return;

    // Read the product's base MOQ from the metafield element
    const minimumQtyEl = document.querySelector('.product-minimum-purchase-qty');
    let baseMinQty = 1;
    if (minimumQtyEl) {
      const parsed = parseInt(minimumQtyEl.textContent.trim(), 10);
      if (!isNaN(parsed) && parsed > 0) {
        baseMinQty = parsed;
      }
    }

    if (anyChecked) {
      // Switch to Overseas, set MOQ to 100, lock tab switching
      overseasTabs.forEach(tab => tab.click());
      quantityInput.setAttribute('data-moq', '100');
      quantityInput.setAttribute('value', '100');
      quantityInput.value = '100';
      if (moqNote) {
        moqNote.style.display = 'block';
      }
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      allTabs.forEach(tab => {
        tab.style.pointerEvents = 'none';
      });
    } else {
      // Revert to product's base MOQ, re-enable tabs
      quantityInput.setAttribute('data-moq', String(baseMinQty));
      quantityInput.setAttribute('value', String(baseMinQty));
      quantityInput.value = String(baseMinQty);
      if (moqNote) {
        moqNote.style.display = 'none';
      }
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (allTabs.length > 0) {
        allTabs[0].click();
      }
      allTabs.forEach(tab => {
        tab.style.pointerEvents = 'auto';
      });
    }
  }

  // -------------------------------------------------------
  // HIDE ORDER TYPE / QUANTITY TIERS + INJECT COLOR PICKERS
  // -------------------------------------------------------
  const customizerOptions = document.querySelectorAll('.tda-customizer-customization-option');

  customizerOptions.forEach(option => {
    const titleEl = option.querySelector('.tda-customizer-customization-option-title');
    const content = option.querySelector('.tda-customizer-customization-option-value-list');
    const contentInput = content ? content.querySelector('input') : null;
    if (!titleEl) return;

    const titleText = titleEl.textContent.trim();

    // Hide Order Type and Quantity Tiers (controlled dynamically)
    if (titleText === 'Order Type' || titleText === 'Quantity Tiers') {
      option.style.display = 'none';
      return;
    }

    // Imprint Color — convert text input to color picker
    if (titleText === 'Imprint Color') {
      const imprintColorInput = option.closest('.tda-customizer-customization-option').querySelector('input[type="text"]');
      if (imprintColorInput) {
        imprintColorInput.type = 'color';
        imprintColorInput.value = '#000000';
        imprintColorInput.style.width = '100%';
        imprintColorInput.style.height = '40px';
        imprintColorInput.style.cursor = 'pointer';
        imprintColorInput.style.border = '0';
        imprintColorInput.style.backgroundColor = 'transparent';
        imprintColorInput.style.padding = '0';
      }
      return;
    }

    // Custom Pantone Color — inject checkbox + color picker UI
    if (titleText.includes('Custom') && content) {
      content.style.margin = '0px';

      // Avoid re-initializing
      if (content.querySelector('.custom-color-picker-wrapper')) return;

      const { wrapper, checkboxLabel } = setupCustomColorOption(content, contentInput, titleText);

      const ctrlWrapper = document.createElement('div');
      ctrlWrapper.className = 'custom-color-control-wrapper';
      ctrlWrapper.appendChild(checkboxLabel);
      ctrlWrapper.appendChild(wrapper);
      content.appendChild(ctrlWrapper);
    }
  });

});

// -------------------------------------------------------
// PRICING TABS — DOMContentLoaded
// -------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll('.product-main__price-tab');
  const tables = document.querySelectorAll('.tiered-pricing-table');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', function () {
      tabs.forEach(tab => tab.classList.remove('product-main__price-tab-active'));
      tables.forEach(table => table.classList.remove('tiered-pricing-table__active'));
      tab.classList.add('product-main__price-tab-active');
      tables[index].classList.add('tiered-pricing-table__active');
      updateTieredPricePerItem();

      setTimeout(() => {
        syncOrderTypeWithTabs();
      }, 100);
    });
  });
});

// -------------------------------------------------------
// HELPERS
// -------------------------------------------------------
const setStyleReset = (selector) => {
  const element = document.querySelector(selector);
  if (!element) return false;
  setTimeout(() => { element.removeAttribute("style"); }, 100);
  return true;
};

const addCustomizerReadyClass = () => {
  const wrapper = document.querySelector(".tda-customizer-wrapper");
  if (wrapper) {
    wrapper.classList.add("tda-customizer__ready");
    return true;
  }
  return false;
};

const resetCustomizerStyles = () => {
  const selectors = [
    ".tda-customizer-app-section-container",
    ".tda-app-section-model-viewer-container",
  ];
  selectors.forEach((selector) => setStyleReset(selector));
};

const addToCartCustom = () => {
  const btn = document.querySelector(".tda-customizer-footer-atc-btn");
  btn.classList.remove("tda-customizer-footer-atc-btn");
  btn.classList.add("button");
  btn.classList.add("tda-customizer-footer-atc-btn-custom");
};

// -------------------------------------------------------
// LOGO UPLOAD LABEL
// Must be at global scope so the second Angle3DCustomizerLoaded
// listener can call it.
// -------------------------------------------------------
function setupLogoUploadLabel() {
  const options = document.querySelectorAll('.tda-customizer-customization-option');

  options.forEach(option => {
    const titleEl = option.querySelector('.tda-customizer-customization-option-title');
    if (!titleEl || !titleEl.textContent.trim().includes('Upload Your Logo')) return;

    const img = option.querySelector('img.tda-file-upload-image');
    if (!img) return;

    const panel  = option.closest('.tda-accordion-panel');
    const button = panel ? panel.previousElementSibling : null;
    if (!button) return;

    const detailSpan = button.querySelector('.selected-option-value-detail-section');
    if (!detailSpan) return;

    const updateLabel = () => {
      const src = img.getAttribute('src') || '';
      const isUploaded = src !== '' && src !== '#';

      if (isUploaded) {
        detailSpan.textContent = 'Logo Uploaded';
      } else {
        detailSpan.textContent = '';
      }
    };

    const obs = new MutationObserver(updateLabel);
    obs.observe(img, { attributes: true, attributeFilter: ['src'] });

    // Run once on init in case a logo is already present
    updateLabel();
  });
}

// -------------------------------------------------------
// IMPRINT COLOR LABEL
// Displays the chosen hex color next to "3. Imprint Color"
// in the accordion header, using the same span other options use.
// Must be at global scope so the second Angle3DCustomizerLoaded
// listener can call it.
// -------------------------------------------------------
function setupImprintColorLabel() {
  const options = document.querySelectorAll('.tda-customizer-customization-option');

  options.forEach(option => {
    const titleEl = option.querySelector('.tda-customizer-customization-option-title');
    if (!titleEl || titleEl.textContent.trim() !== 'Imprint Color') return;

    const colorInput = option.querySelector('input[type="color"]');
    if (!colorInput) return;

    const panel  = option.closest('.tda-accordion-panel');
    const button = panel ? panel.previousElementSibling : null;
    if (!button) return;

    const detailSpan = button.querySelector('.selected-option-value-detail-section');
    if (!detailSpan) return;

    const updateLabel = () => {
      detailSpan.textContent = colorInput.value || '';
    };

    colorInput.addEventListener('input',  updateLabel);
    colorInput.addEventListener('change', updateLabel);

    // Run once on init to reflect any pre-set value
    updateLabel();
  });
}

// -------------------------------------------------------
// TIERED PRICE CALCULATOR
// -------------------------------------------------------
function updateTieredPricePerItem() {
  const qtyInput = document.querySelector(".tda-customizer-footer-qty input.quantity-field");
  if (!qtyInput) return;
  const currentQty = parseInt(qtyInput.value);
  const totalQtyNum = document.querySelector(".total-prd-qty-num");
  if (totalQtyNum) totalQtyNum.textContent = qtyInput.value;

  const isDomesticTabActive = document
    .querySelector(".product-main__price-tab.product-main__price-tab-domestic")
    ?.classList.contains("product-main__price-tab-active");

  const isOverseasTabActive = document
    .querySelector(".product-main__price-tab.product-main__price-tab-overseas")
    ?.classList.contains("product-main__price-tab-active");

  if (!isDomesticTabActive && !isOverseasTabActive) return;

  const quantityBreakpoints = document.querySelectorAll(".tiered-pricing-table-domestic .domestic_table_qty_row td");
  const correspondingPrices = document.querySelectorAll(".tiered-pricing-table-domestic .domestic_table_price_row td");

  let applicablePrice = null;

  quantityBreakpoints.forEach((qtyCell, i) => {
    const minQty = parseInt(qtyCell.getAttribute("quantity").replace(",", ""));
    const nextMinQtyCell = quantityBreakpoints[i + 1];
    const nextMinQty = nextMinQtyCell
      ? parseInt(nextMinQtyCell.getAttribute("quantity").replace(",", ""))
      : Infinity;

    if (currentQty >= minQty && currentQty < nextMinQty) {
      applicablePrice = parseFloat(correspondingPrices[i].getAttribute("price"));
    }
  });

  if (applicablePrice !== null) {
    let addonTotalPrice = 0;

    const panels = document.querySelectorAll(".tda-customizer-customization-options-container div.tda-accordion-panel");

    panels.forEach(panel => {
      const valueList = panel.querySelector("div.tda-customizer-customization-option-value-list");

      if (valueList && !valueList.dataset.bound) {
        const options = valueList.querySelectorAll(".tda-customizer-customization-option-value");
        options.forEach(option => {
          option.addEventListener("click", () => {
            setTimeout(() => { updateTieredPricePerItem(); }, 100);
          });
        });
        valueList.dataset.bound = "true";
      }

      const selected = panel.querySelector(".tda-customizer-customization-option-value-selected");
      if (selected) {
        let optionPrice = 0;
        const priceSpan = selected.querySelector("span");
        if (priceSpan) {
          const spanText = priceSpan.textContent.trim();
          const priceMatch = spanText.match(/\+?\$?(\d+(?:\.\d+)?)/);
          if (priceMatch) {
            optionPrice = parseFloat(priceMatch[1]);
          }
        }
        addonTotalPrice += optionPrice;
      }
    });

    const basePrice = isOverseasTabActive
      ? applicablePrice * 0.8
      : applicablePrice;

    const finalPrice = (basePrice + addonTotalPrice).toFixed(2);

    const pricePerItem = document.querySelector(".prd-discounted-price-per-item-num");
    if (pricePerItem) pricePerItem.textContent = finalPrice;

    const totalPrice = (parseFloat(finalPrice) * currentQty).toFixed(2);
    const totalPriceNum = document.querySelector(".prd-total-price-num");
    if (totalPriceNum) totalPriceNum.textContent = totalPrice;
  }
}

// -------------------------------------------------------
// SYNC ORDER TYPE WITH ACTIVE PRICING TAB
// -------------------------------------------------------
function syncOrderTypeWithTabs() {
  const isDomesticTabActive = document
    .querySelector(".product-main__price-tab.product-main__price-tab-domestic")
    ?.classList.contains("product-main__price-tab-active");

  const isOverseasTabActive = document
    .querySelector(".product-main__price-tab.product-main__price-tab-overseas")
    ?.classList.contains("product-main__price-tab-active");

  const orderTypeOptions = document.querySelectorAll('.tda-customizer-customization-option');

  orderTypeOptions.forEach(option => {
    const title = option.querySelector('.tda-customizer-customization-option-title');
    if (title && title.textContent.trim() === 'Order Type') {
      const allOptions = option.querySelectorAll('.tda-customizer-customization-option-value');
      allOptions.forEach(optionValue => {
        const titleElement = optionValue.querySelector('.tda-customizer-customization-option-value-title');
        if (titleElement) {
          const optionText = titleElement.textContent.trim();
          if ((isDomesticTabActive && optionText === 'Domestic') ||
              (isOverseasTabActive && optionText === 'Overseas')) {
            if (!optionValue.classList.contains('tda-customizer-customization-option-value-selected')) {
              optionValue.click();
            }
          }
        }
      });
    }
  });
}

// -------------------------------------------------------
// SYNC QUANTITY WITH TIER OPTIONS
// -------------------------------------------------------
function syncQuantityWithTiers() {
  const qtyInput = document.querySelector(".tda-customizer-footer-qty input.quantity-field");
  if (!qtyInput) return;

  const currentQty = parseInt(qtyInput.value);

  const isDomesticActive = document
    .querySelector(".tiered-pricing-table-domestic")
    ?.classList.contains("tiered-pricing-table__active");

  const tableSelector = isDomesticActive
    ? ".tiered-pricing-table-domestic .domestic_table_qty_row td"
    : ".tiered-pricing-table-overseas .overseas_table_qty_row td";

  const quantityBreakpoints = document.querySelectorAll(tableSelector);

  let targetTier = null;
  let targetTierText = null;

  const breakpointData = [];
  quantityBreakpoints.forEach((qtyCell) => {
    if (qtyCell.hasAttribute("quantity")) {
      const minQty = parseInt(qtyCell.getAttribute("quantity").replace(/,/g, ""));
      const displayText = qtyCell.textContent.trim();
      breakpointData.push({ minQty, displayText, element: qtyCell });
    }
  });

  breakpointData.sort((a, b) => a.minQty - b.minQty);

  for (let i = 0; i < breakpointData.length; i++) {
    const current = breakpointData[i];
    const next = breakpointData[i + 1];
    if (next) {
      if (currentQty >= current.minQty && currentQty < next.minQty) {
        targetTier = current.minQty.toString();
        targetTierText = current.displayText;
        break;
      }
    } else {
      if (currentQty >= current.minQty) {
        targetTier = current.minQty.toString();
        targetTierText = current.displayText;
        break;
      }
    }
  }

  if (!targetTier && breakpointData.length > 0) {
    targetTier = breakpointData[0].minQty.toString();
    targetTierText = breakpointData[0].displayText;
  }

  if (targetTier && targetTierText) {
    const quantityTierOptions = document.querySelectorAll('.tda-customizer-customization-option');
    quantityTierOptions.forEach(option => {
      const title = option.querySelector('.tda-customizer-customization-option-title');
      if (title && title.textContent.trim() === 'Quantity Tiers') {
        const allOptions = option.querySelectorAll('.tda-customizer-customization-option-value');
        allOptions.forEach(optionValue => {
          const titleElement = optionValue.querySelector('.tda-customizer-customization-option-value-title');
          if (titleElement) {
            const optionText = titleElement.textContent.trim();
            if (optionText === targetTierText) {
              if (!optionValue.classList.contains('tda-customizer-customization-option-value-selected')) {
                optionValue.click();
              }
            }
          }
        });
      }
    });
  }
}

// -------------------------------------------------------
// ADD SYNCED CART BUTTON + QTY LOGIC
// -------------------------------------------------------
const addSyncedCartButton = () => {
  // ── MAX QUANTITY LIMIT (Shopify platform cap) ──────────────────────────
  const MAX_QTY = 1000000;

  const container = document.querySelector(".tda-customizer-controls-container");
  const client_approval_mockup_text = document.querySelector(".client-approval-mockup-text");
  const total_qty_pricing = document.querySelector(".total-qty-pricing-wrap");
  const qty = document.querySelector(".tda-customizer-footer-qty");
  const qtyInput = qty.querySelector("input.quantity-field");

  // Read MOQ from product metafield
  const minimumQtyEl = document.querySelector(".product-minimum-purchase-qty");
  let minQty = 1;
  if (minimumQtyEl) {
    const parsed = parseInt(minimumQtyEl.textContent.trim(), 10);
    if (!isNaN(parsed) && parsed > 0) {
      minQty = parsed;
    }
  }

  qtyInput.setAttribute("min", String(minQty));
  qtyInput.setAttribute("max", MAX_QTY); // ── enforce platform cap
  qtyInput.setAttribute("data-moq", String(minQty));
  qtyInput.setAttribute("value", String(minQty));
  qtyInput.value = String(minQty);
  document.querySelector(".total-prd-qty-num").textContent = qtyInput.value;

  // ── Helper to disable/enable the plus button at the max limit ─────────
  const plusBtn = qty.querySelector(".button-plus");
  const updatePlusBtn = () => {
    const currentVal = parseInt(qtyInput.value);
    if (currentVal >= MAX_QTY) {
      plusBtn.disabled = true;
      plusBtn.setAttribute("aria-disabled", "true");
    } else {
      plusBtn.disabled = false;
      plusBtn.removeAttribute("aria-disabled");
    }
  };
  // ─────────────────────────────────────────────────────────────────────

  qtyInput.addEventListener("input", () => {
    // Cap typed value at MAX_QTY immediately
    if (parseInt(qtyInput.value) > MAX_QTY) {
      qtyInput.value = MAX_QTY;
    }
    updateTieredPricePerItem();
    updatePlusBtn(); // ── NEW
    setTimeout(() => { syncQuantityWithTiers(); }, 100);
  });
  qtyInput.addEventListener("keydown", (e) => {
    if (e.key === "Enter") validateQty();
  });
  qtyInput.addEventListener("blur", () => {
    validateQty();
  });

  function validateQty() {
    let current = parseInt(qtyInput.value);
    const moq = parseInt(qtyInput.getAttribute('data-moq'), 10) || minQty;
    if (isNaN(current) || current < moq) {
      qtyInput.value = String(moq);
    }
    // Also cap at MAX_QTY on validate
    if (parseInt(qtyInput.value) > MAX_QTY) {
      qtyInput.value = MAX_QTY;
    }
    document.querySelector(".total-prd-qty-num").textContent = qtyInput.value;
    updateTieredPricePerItem();
    updatePlusBtn(); // ── NEW
    setTimeout(() => { syncQuantityWithTiers(); }, 100);
  }

  const minusBtn = qty.querySelector(".button-minus");
  minusBtn.addEventListener("click", () => {
    setTimeout(() => {
      const newQty = parseInt(qtyInput.value);
      const moq = parseInt(qtyInput.getAttribute('data-moq'), 10) || minQty;
      const newVal = newQty - 1;
      if (newVal >= moq) {
        qtyInput.value = newVal;
      } else {
        qtyInput.value = String(moq);
      }
      updateTieredPricePerItem();
      document.querySelector(".total-prd-qty-num").textContent = qtyInput.value;
      updatePlusBtn(); // ── NEW
      syncQuantityWithTiers();
    });
  });

  plusBtn.addEventListener("click", () => {
    setTimeout(() => {
      // Prevent going above MAX_QTY
      if (parseInt(qtyInput.value) > MAX_QTY) {
        qtyInput.value = MAX_QTY;
      }
      updateTieredPricePerItem();
      updatePlusBtn(); // ── NEW
      syncQuantityWithTiers();
    });
  });

  // Run once on load so button state is correct from the start
  updatePlusBtn(); // ── NEW

  // Build custom ATC button
  const newButton = document.createElement("button");
  const qtyAppBefore = document.createElement("div");
  const client_approval_mockup = document.createElement("div");
  const qtyAppAfter = document.createElement("div");
  qtyAppBefore.className = "qty-app__before";
  client_approval_mockup.className = "client-approval-mockup-text-wrap";
  qtyAppAfter.className = "qty-app__after";
  newButton.textContent = "Add to Cart";
  newButton.className = "button tda-custom__add";

  const originalButton = document.querySelector(".tda-customizer-footer-atc-btn-custom");

  // MOQ note (hidden by default, shown when custom color checked)
  const moqNote = document.createElement("div");
  moqNote.className = "MOq_Note";
  moqNote.style.display = "none";
  moqNote.textContent = "Custom Pantone fabrication automatically applies Overseas pricing & timing and a 100 unit MOQ.";

  newButton.addEventListener("click", () => {
    newButton.disabled = true;
    newButton.innerHTML = '<span class="loading-spinner"></span> Adding...';
    newButton.classList.add('loading');
    originalButton.click();
  });

  const observer = new MutationObserver(() => {
    newButton.disabled = originalButton.disabled;
  });
  observer.observe(originalButton, {
    attributes: true,
    attributeFilter: ["disabled"],
  });
  newButton.disabled = originalButton.disabled;

  qtyAppBefore.appendChild(qty);
  client_approval_mockup.appendChild(client_approval_mockup_text);
  qtyAppAfter.appendChild(total_qty_pricing);
  container.appendChild(qtyAppBefore);
  container.appendChild(moqNote);
  container.appendChild(qtyAppAfter);
  container.appendChild(newButton);
  container.appendChild(client_approval_mockup);

  updateTieredPricePerItem();
};

// -------------------------------------------------------
// MOVE CUSTOM ELEMENTS INTO CORRECT CONTAINER
// -------------------------------------------------------
const addCustomElement = () => {
  const targetContainer = document.querySelector(".tda-product-details-top-container");
  const targetContainerMobile1024 = document.querySelector(".tda-customizer-customization-options-container");

  const elements = [
    document.querySelector(".product-sample"),
    document.querySelector(".product-inquiry"),
    document.querySelector(".product-main__price-table"),
    document.querySelector(".product-main__code"),
  ];

  const moveElements = () => {
    const container = window.innerWidth <= 1024 ? targetContainerMobile1024 : targetContainer;
    elements.forEach((element) => {
      if (element && container) {
        container.after(element);
      }
    });
  };

  moveElements();
  window.addEventListener("resize", moveElements);
  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(() => { moveElements(); });
    resizeObserver.observe(document.body);
  }
};

addCustomElement();

// -------------------------------------------------------
// ANGLE3D LOADED — WIRE EVERYTHING UP
// -------------------------------------------------------
window.addEventListener("Angle3DCustomizerLoaded", (event) => {
  addCustomizerReadyClass();
  resetCustomizerStyles();
  addToCartCustom();
  addSyncedCartButton();
  addCustomElement();
  setupLogoUploadLabel();    // ── show "Logo Uploaded" label next to accordion title
  setupImprintColorLabel();  // ── show chosen hex color next to "Imprint Color"
});

// -------------------------------------------------------
// MODALS
// -------------------------------------------------------
document.addEventListener("DOMContentLoaded", () => {
  const modals = [
    {
      modal: document.getElementById("inquiry-form__dialog"),
      openBtn: document.getElementById("inquiry-form__dialog-open"),
      closeBtn: document.getElementById("inquiry-form__dialog-close"),
    },
    {
      modal: document.getElementById("sample-form__dialog"),
      openBtn: document.getElementById("sample-form__dialog-open"),
      closeBtn: document.getElementById("sample-form__dialog-close"),
    },
  ];

  modals.forEach(({ modal, openBtn, closeBtn }) => {
    if (modal && openBtn && closeBtn) {
      openBtn.addEventListener("click", () => modal.showModal());
      closeBtn.addEventListener("click", () => modal.close());
      modal.addEventListener("keydown", (e) => {
        if (e.key === "Escape") modal.close();
      });
    }
  });
});

// =======================================================
// MOCKUP IMAGE GALLERY  (custom — additional, self-contained)
// -------------------------------------------------------
// Moves the Liquid-rendered `.wnr-mockup-gallery` block to sit right under
// the 3D model viewer (`.tda-app-section-model-viewer-sticky-container`) and
// wires up the thumbnail strip + lightbox modal (images & videos).
// Nothing above this block is modified.
// =======================================================
(function () {
  var GALLERY_SELECTOR = ".wnr-mockup-gallery";
  var STICKY_SELECTOR = ".tda-app-section-model-viewer-sticky-container";
  var CONTAINER_SELECTOR = ".tda-app-section-model-viewer-container";
  var MOBILE_QUERY = "(max-width: 1023px)";

  // Place the gallery responsively:
  //  - >= 1024px : right after the sticky container (inside the viewer container)
  //  - <= 1023px : right after the viewer container itself
  function placeMockupGallery() {
    var gallery = document.querySelector(GALLERY_SELECTOR);
    if (!gallery) return;
    var isMobile = window.matchMedia(MOBILE_QUERY).matches;
    var container = document.querySelector(CONTAINER_SELECTOR);
    var sticky = document.querySelector(STICKY_SELECTOR);

    if (isMobile && container) {
      if (container.nextElementSibling !== gallery) container.after(gallery);
    } else if (sticky) {
      if (sticky.nextElementSibling !== gallery) sticky.after(gallery);
    }
  }

  // Returns: 'done' (mounted / nothing to do), 'waiting' (gallery exists but
  // the 3D viewer container is not in the DOM yet), or 'no-gallery'.
  function mountMockupGallery() {
    var gallery = document.querySelector(GALLERY_SELECTOR);
    if (!gallery) return "no-gallery";
    if (gallery.dataset.wnrMounted === "true") return "done";

    var sticky = document.querySelector(STICKY_SELECTOR);
    if (!sticky) return "waiting";

    gallery.dataset.wnrMounted = "true";
    placeMockupGallery(); // initial responsive placement
    wireMockupGallery(gallery);

    // Re-place on viewport changes (debounced).
    var t;
    window.addEventListener("resize", function () {
      window.clearTimeout(t);
      t = window.setTimeout(placeMockupGallery, 150);
    });
    window.addEventListener("orientationchange", placeMockupGallery);
    return "done";
  }

  function wireMockupGallery(root) {
    var modal = root.querySelector("[data-wnr-modal]");
    var mainTrack = root.querySelector("[data-wnr-main-track]");
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-wnr-slide]"));
    var count = slides.length;
    if (!modal || !mainTrack || count === 0) return;

    var mainPrev = root.querySelector("[data-wnr-main-prev]");
    var mainNext = root.querySelector("[data-wnr-main-next]");
    var inlineThumbs = Array.prototype.slice.call(root.querySelectorAll("[data-wnr-thumb]"));
    var modalThumbs = Array.prototype.slice.call(root.querySelectorAll("[data-wnr-modal-thumb]"));
    var stripTrack = root.querySelector("[data-wnr-strip-track]");
    var modalThumbsTrack = root.querySelector("[data-wnr-modal-thumbs-track]");

    var activeIndex = 0;
    var suppressScroll = false; // ignore scroll events during programmatic scroll
    var updateModalThumbsDisabled = null; // set by bindStripArrows for the modal strip

    // ---- arrow visibility rules ----
    // Main viewer arrows: only when there is more than 1 item.
    if (count > 1) {
      if (mainPrev) mainPrev.classList.add("wnr-mockup-modal__nav--visible");
      if (mainNext) mainNext.classList.add("wnr-mockup-modal__nav--visible");
    }
    // Thumbnail arrows (inline + modal): only when more than 4 items combined.
    if (count > 4) {
      root
        .querySelectorAll(
          "[data-wnr-strip-prev],[data-wnr-strip-next],[data-wnr-modal-thumbs-prev],[data-wnr-modal-thumbs-next]"
        )
        .forEach(function (a) {
          a.classList.add("wnr-mockup-arrow--visible");
        });
    }

    function scrollMainTo(index, instant) {
      suppressScroll = true;
      mainTrack.scrollTo({
        left: index * mainTrack.clientWidth,
        behavior: instant ? "auto" : "smooth",
      });
      window.setTimeout(function () {
        suppressScroll = false;
      }, instant ? 60 : 420);
    }

    function centerThumb(thumb) {
      var track = thumb.parentElement;
      if (!track) return;
      var trackRect = track.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      var delta =
        thumbRect.left - trackRect.left - (track.clientWidth - thumb.clientWidth) / 2;
      track.scrollBy({ left: delta, behavior: "smooth" });
    }

    function updateThumbActive(index) {
      [inlineThumbs, modalThumbs].forEach(function (list) {
        list.forEach(function (t) {
          var ti = parseInt(t.getAttribute("data-wnr-index"), 10);
          var isActive = ti === index;
          t.classList.toggle("wnr-mockup-thumb--active", isActive);
          if (isActive) centerThumb(t);
        });
      });
    }

    function updateMainArrows() {
      if (mainPrev) mainPrev.disabled = activeIndex <= 0;
      if (mainNext) mainNext.disabled = activeIndex >= count - 1;
    }

    function pauseVideosExcept(keepIndex) {
      slides.forEach(function (slide, i) {
        if (i === keepIndex) return;
        var v = slide.querySelector("[data-wnr-video]");
        if (v) {
          v.pause();
          slide.classList.remove("wnr-mockup-slide--playing");
        }
      });
    }

    // Play the active slide's video (if any). Must be called synchronously
    // from a user gesture so the browser allows un-muted playback.
    function playActiveVideo() {
      var slide = slides[activeIndex];
      if (!slide) return;
      var v = slide.querySelector("[data-wnr-video]");
      if (!v) return;
      var p = v.play();
      if (p && typeof p.catch === "function") {
        p.catch(function () {
          /* autoplay blocked — overlay play icon stays visible */
        });
      }
    }

    // Navigate (used by arrows + modal thumbnails, always from a gesture).
    function goTo(index, play) {
      if (index < 0) index = 0;
      if (index > count - 1) index = count - 1;
      activeIndex = index;
      scrollMainTo(index, false);
      updateThumbActive(index);
      updateMainArrows();
      pauseVideosExcept(index);
      if (play) playActiveVideo();
    }

    // ---- main viewer manual scroll => keep active index in sync ----
    var scrollTimer;
    mainTrack.addEventListener("scroll", function () {
      if (suppressScroll) return;
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        var w = mainTrack.clientWidth || 1;
        var idx = Math.round(mainTrack.scrollLeft / w);
        if (idx !== activeIndex) {
          activeIndex = idx;
          updateThumbActive(idx);
          updateMainArrows();
          pauseVideosExcept(idx); // pause whatever we scrolled away from
        }
      }, 120);
    });

    // ---- modal open / close ----
    function openModal(index) {
      activeIndex = index < 0 ? 0 : index > count - 1 ? count - 1 : index;
      modal.hidden = false;
      document.body.classList.add("wnr-mockup-modal-open");
      updateThumbActive(activeIndex);
      updateMainArrows();
      pauseVideosExcept(activeIndex);
      playActiveVideo(); // synchronous => stays within the click gesture
      // Position the main track + recompute thumb-arrow state once the modal
      // has real layout (it was display:none, so widths were 0 until now).
      window.requestAnimationFrame(function () {
        scrollMainTo(activeIndex, true);
        if (updateModalThumbsDisabled) updateModalThumbsDisabled();
      });
    }

    function closeModal() {
      pauseVideosExcept(-1); // pause everything
      modal.hidden = true;
      document.body.classList.remove("wnr-mockup-modal-open");
    }

    // Keep the open modal's main viewer aligned to the active slide if the
    // viewport changes size (e.g. mobile rotation). No-op while modal closed.
    var resizeRealign;
    function realignOnResize() {
      if (modal.hidden) return;
      suppressScroll = true;
      window.clearTimeout(resizeRealign);
      resizeRealign = window.setTimeout(function () {
        scrollMainTo(activeIndex, true);
        if (updateModalThumbsDisabled) updateModalThumbsDisabled();
      }, 120);
    }
    window.addEventListener("resize", realignOnResize);
    window.addEventListener("orientationchange", realignOnResize);

    inlineThumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        openModal(parseInt(t.getAttribute("data-wnr-index"), 10));
      });
    });
    modalThumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        goTo(parseInt(t.getAttribute("data-wnr-index"), 10), true);
      });
    });

    root.querySelectorAll("[data-wnr-modal-close]").forEach(function (b) {
      b.addEventListener("click", closeModal);
    });
    document.addEventListener("keydown", function (e) {
      if (!modal.hidden && e.key === "Escape") closeModal();
    });

    if (mainPrev) {
      mainPrev.addEventListener("click", function () {
        if (!mainPrev.disabled) goTo(activeIndex - 1, true);
      });
    }
    if (mainNext) {
      mainNext.addEventListener("click", function () {
        if (!mainNext.disabled) goTo(activeIndex + 1, true);
      });
    }

    // ---- thumbnail strip arrows (scroll the strip) ----
    function bindStripArrows(track, prevSel, nextSel) {
      if (!track) return;
      var prev = root.querySelector(prevSel);
      var next = root.querySelector(nextSel);
      var step = function () {
        return track.clientWidth * 0.8;
      };
      if (prev) {
        prev.addEventListener("click", function () {
          track.scrollBy({ left: -step(), behavior: "smooth" });
        });
      }
      if (next) {
        next.addEventListener("click", function () {
          track.scrollBy({ left: step(), behavior: "smooth" });
        });
      }
      function updateDisabled() {
        var max = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.disabled = track.scrollLeft <= 0;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      var t;
      track.addEventListener("scroll", function () {
        window.clearTimeout(t);
        t = window.setTimeout(updateDisabled, 80);
      });
      updateDisabled();
      return updateDisabled;
    }
    bindStripArrows(stripTrack, "[data-wnr-strip-prev]", "[data-wnr-strip-next]");
    // Captured so it can be re-run once the modal has real layout (see openModal).
    updateModalThumbsDisabled = bindStripArrows(
      modalThumbsTrack,
      "[data-wnr-modal-thumbs-prev]",
      "[data-wnr-modal-thumbs-next]"
    );

    // ---- video click-to-toggle + play-icon overlay sync ----
    slides.forEach(function (slide) {
      var v = slide.querySelector("[data-wnr-video]");
      if (!v) return;
      var toggle = slide.querySelector("[data-wnr-video-toggle]");
      var togglePlay = function (e) {
        if (e) e.preventDefault();
        if (v.paused) {
          v.play();
        } else {
          v.pause();
        }
      };
      if (toggle) toggle.addEventListener("click", togglePlay);
      v.addEventListener("click", togglePlay);
      v.addEventListener("play", function () {
        slide.classList.add("wnr-mockup-slide--playing");
      });
      v.addEventListener("pause", function () {
        slide.classList.remove("wnr-mockup-slide--playing");
      });
      v.addEventListener("ended", function () {
        slide.classList.remove("wnr-mockup-slide--playing");
      });
    });

    // initial state (modal closed)
    updateThumbActive(0);
    updateMainArrows();

    // Portal the modal to <body> so its position:fixed is relative to the real
    // viewport. An app/theme ancestor using transform/filter/contain would
    // otherwise become the containing block, leaving the overlay short of the
    // page and the dialog off-centre. Done LAST so every listener above (close
    // button, overlay, modal thumb arrows) is wired while the modal is still in
    // `root`. Carry the gallery's CSS variables across so the modal thumbnails
    // keep their sizing once detached from .wnr-mockup-gallery.
    var cs = window.getComputedStyle(root);
    ["--wnr-thumb-gap", "--wnr-thumb-size", "--wnr-accent"].forEach(function (name) {
      var value = cs.getPropertyValue(name);
      if (value) modal.style.setProperty(name, value.trim());
    });
    document.body.appendChild(modal);
  }

  // ---- bootstrap: try on the app's ready event, with a polling fallback ----
  function startPollingForViewer() {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      var status = mountMockupGallery();
      if (status !== "waiting" || tries > 40) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  function boot() {
    if (mountMockupGallery() === "waiting") startPollingForViewer();
  }

  // The 3D app fires this once its viewer is rendered.
  window.addEventListener("Angle3DCustomizerLoaded", boot);
  // Also attempt on DOM ready in case the event already fired earlier.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();